// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Welcome_welcome__xlpmk"};